// @generated by protoc-gen-connect-query v2.2.0 with parameter "target=ts"
// @generated from file bffuser/v1/jepx_settlement_service.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import { JepxSettlementService } from "./jepx_settlement_service_pb";

/**
 * ListJepxSettlements returns the 清算書 of one market, newest 清算日 first.
 * 全件を返し、 ページ送りの引数は無い。 JEPX 会員ID が未設定の組織は
 * jepx_member_registered = false と空の一覧 (AC-JST-004)。
 *
 * @generated from rpc bffuser.v1.JepxSettlementService.ListJepxSettlements
 */
export const listJepxSettlements = JepxSettlementService.method.listJepxSettlements;

/**
 * GetJepxSettlementSummary returns one 清算書's 見出し and 明細 (AC-JST-007 の
 * CSV の元)。 件名は JEPX の原文、 金額は JEPX の符号のまま (負 = 会員が支払う)。
 * 組織は session から決まり、 request に載せない。
 *
 * @generated from rpc bffuser.v1.JepxSettlementService.GetJepxSettlementSummary
 */
export const getJepxSettlementSummary = JepxSettlementService.method.getJepxSettlementSummary;

/**
 * DownloadJepxSettlementPdf returns the 清算書 PDF JEPX issued, byte for byte
 * (AC-JST-006)。 組織は session から決まり、 request に載せない。
 *
 * @generated from rpc bffuser.v1.JepxSettlementService.DownloadJepxSettlementPdf
 */
export const downloadJepxSettlementPdf = JepxSettlementService.method.downloadJepxSettlementPdf;
